import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
// Helper to flatten subtopics map into an array for navigation state
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const AIModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5', 'Module 6', 'Module 7'
  ];

  // Define subtopics for each module as per your specification
  const subtopicsData = {
    'Module 1': [
      { name: 'Introduction- Evolution of AI, State of Art - Types of AI', path: '/ai-m1-s1' },
      { name: 'Intelligent Agents- Structure of Intelligent Agents', path: '/ai-m1-s2' },
      { name: 'Environments and PEAS', path: '/ai-m1-s3' }
    ],
    'Module 2': [
      { name: 'Introduction to Problem Solving by searching Methods-State Space search', path: '/ai-m2-s1' },
      { name: 'Uninformed Search Methods – Uniform Cost Search, Breadth First Search, Depth First Search, Depth-limited search, Iterative deepening depth-first', path: '/ai-m2-s2' },
      { name: 'Informed Search Methods- Best First Search, A* Search', path: '/ai-m2-s3' }
    ],
    'Module 3': [
      { name: 'Local search algorithms - hill climbing search, simulated annealing, genetic algorithm', path: '/ai-m3-s1' },
      { name: 'Adversarial Search: Game Trees and Minimax Evaluation', path: '/ai-m3-s2' },
      { name: 'Elementary two-players games: tic-tac-toe, Minimax with Alpha-Beta Pruning', path: '/ai-m3-s3' }
    ],
    'Module 4': [
      { name: 'Introduction to Logic and Reasoning-Propositional Logic', path: '/ai-m4-s1' },
      { name: 'First Order Logic-Inference in First Order Logic', path: '/ai-m4-s2' },
      { name: 'Unification, Forward Chaining, Backward Chaining, Resolution', path: '/ai-m4-s3' }
    ],
    'Module 5': [
      { name: 'Quantifying Uncertainty', path: '/ai-m5-s1' },
      { name: 'Bayes Rule -Bayesian Belief Network', path: '/ai-m5-s2' }
    ],
    'Module 6': [
      { name: 'Classical planning', path: '/ai-m6-s1' },
      { name: 'Planning as State-space search, Forward search, backward search', path: '/ai-m6-s2' },
      { name: 'Planning graphs, Hierarchical Planning', path: '/ai-m6-s3' },
      { name: 'Planning and acting in Nondeterministic domains – Sensor-less Planning, Multiagent planning', path: '/ai-m6-s4' }
    ],
    'Module 7': [
      { name: 'Communication-Fundamentals of Language -Probabilistic Language Processing', path: '/ai-m7-s1' },
      { name: 'Information Retrieval- Information Extraction-Perception', path: '/ai-m7-s2' },
      { name: 'Image Formation- Object Recognition', path: '/ai-m7-s3' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Artificial Intelligence</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-AIModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>No topics available.</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AIModules;
